import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Colton Wiscombe
 * id 8C535C82-EAA1-431A-90AE-D0A5032024EB
 * name truck-cargo-container
 * version: 6.3.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/truck-cargo-container.svg
 * tags
 * - Transportation + Road 
 */
export const TruckCargoContainerIcon = createSvgIcon(<><path d="M20 8H17V4H1V17H3C3 18.66 4.34 20 6 20S9 18.66 9 17H15C15 18.66 16.34 20 18 20S21 18.66 21 17H23V12L20 8M6 18.5C5.17 18.5 4.5 17.83 4.5 17S5.17 15.5 6 15.5 7.5 16.17 7.5 17 6.83 18.5 6 18.5M15 7H13V14H11V7H9V14H7V7H5V14H3V6H15V7M18 18.5C17.17 18.5 16.5 17.83 16.5 17S17.17 15.5 18 15.5 19.5 16.17 19.5 17 18.83 18.5 18 18.5M17 12V9.5H19.5L21.46 12H17Z" /></>, 'TruckCargoContainerIcon');
export default TruckCargoContainerIcon